// package imports
import { Col, Row } from 'react-bootstrap'
// project imports
import './gap-product-card.css'
import QmsQuoteStatus from 'constants/QmsQuoteStatus'
import QmsStorageKeys from 'constants/QmsStorageKeys'
import StorageKeys from 'constants/StorageKeys'
import QmsSolutionStatus from 'constants/QmsSolutionStatus'

const policyResumeUrl = process.env.REACT_APP_QMS_TO_PRAGATI_POLICY_RESUME_URL
const policyAppTrackerUrl = process.env.REACT_APP_QMS_TO_PRAGATI_POLICY_APP_TRACKER_URL
const qmsDashboardUrl = process.env.REACT_APP_QMS_DASHBOARD_URL

const GapProductCard = (props) => {
    const { productList, proposerData, journeyId } = props

    return (
        <>
            <Col className=' gap-col-6 text-center border-column px-4' >
                {productList.map((item, index) =>
                    <>
                        <Row className='my-1'>
                            <div className='gap-outer-above-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>New Product</p>
                                <div className=' mx-1 border my-1 font-size-13'>{item?.new_product_name}</div>
                            </div>
                        </Row>
                        <hr className='my-1' style={{ border: '1px dashed gray' }} ></hr>
                        <Row className='my-1'>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>Target Amt</p>
                                <div className=' mx-1 border my-1 font-size-13'>{global.toINR(item?.target_amount)}</div>
                            </div>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>Premium</p>
                                <div className=' mx-1 border my-1 font-size-13'>{global.toINR(item?.premium)}</div>
                            </div>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>PT</p>
                                <div className=' mx-1 border my-1 font-size-13'>{item?.pt}</div>
                            </div>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>PPT</p>
                                <div className=' mx-1 border my-1 font-size-13'>{item?.ppt}</div>
                            </div>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>You Get</p>
                                <div className=' mx-1 border my-1 font-size-13'>{global.toINR(item?.new_you_get)}</div>
                            </div>
                            <div className='gap-outer-col-2'>
                                <p className='font-size-12 mb-0 text-primary'>You Give</p>
                                <div className=' mx-1 border my-1 font-size-13'>{global.toINR(item?.you_give)}</div>
                            </div>
                        </Row>
                        {proposerData?.button_style?.solution_status_id === QmsSolutionStatus.APPLICATION_IN_PROGRESS &&
                            <Row className=''><div className={`border my-1 w-100 font-size-13 rounded my-2 d-md-none d-block pointer`} style={{ backgroundColor: item?.button_color, color: item?.button_text_color }} onClick={() => { props.setStartApplicationClick(proposerData.solution_id, proposerData?.proposer_id, journeyId, item) }}>{item?.button_text}</div></Row>
                        }
                        {productList.length !== index + 1 && (
                            <hr className='my-1' style={{ border: '2px solid gray' }} ></hr>
                        )}

                        {item.status_id !== QmsQuoteStatus.PROPOSAL_COMPLETED ? (
                            <div>
                                <form className='d-none' id={`quotation-status-form-post-call-uniqueId-${item?.application_number}`} action={policyResumeUrl} method={"POST"}>
                                    <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
                                    <input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
                                    <input type='text' name='Vendor' value={localStorage.getItem(QmsStorageKeys.VENDOR)} />
                                    <input type='text' name='SourceFrom' value={"NA"} />
                                    <input type='text' name='Policy_number' value={item?.policy_number} />
                                    <input type='text' name='Application_number' value={item?.application_number} />
                                    <button type='submit'>Submit</button>
                                </form>
                            </div>
                        ) : (
                            <div></div>
                        )}

                        {item.status_id === QmsQuoteStatus.PROPOSAL_COMPLETED ? (
                            <div>
                                <form className='d-none' id={`quotation-status-form-post-call-uniqueId-${item?.application_number}`} action={policyAppTrackerUrl} method={"POST"}>
                                    <input type='text' name='Policy_number' value={item?.policy_number} />
                                    <input type='text' name='Application_number' value={item?.application_number} />
                                    <input type='text' name='DOB' value={proposerData?.proposer_dob} />
                                    <input type='text' name='Reverse_URL' value={`${qmsDashboardUrl}?agent_id=${localStorage.getItem(QmsStorageKeys.AGENT_ID)}&token=${sessionStorage.getItem(StorageKeys.AUTH_TOKEN)}`} />
                                    <input type='text' name='SourceFrom' value={"NA"} />
                                    <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
                                    <input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
                                    <input type='text' name='Vendor' value={"ETLI"} />
                                    <button type='submit'>Submit</button>
                                </form>
                            </div>
                        ) : (
                            <div></div>
                        )}

                    </>
                )}
            </Col >
        </>
    )
}
export default GapProductCard